import { Box, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { LanguageSwitcher } from "@/components/layout/header/LanguageSwitcher";

import { UnauthFooterCorner } from "./UnauthFooterCorner";

interface AuthPageLayoutProps {
  children: React.ReactNode;
}

export const AuthPageLayout = ({ children }: AuthPageLayoutProps) => {
  const { palette } = useTheme();

  return (
    <Stack
      minHeight="100vh"
      bgcolor={palette.background.page}
      position="relative"
      alignItems="center"
      justifyContent="center"
    >
      <Box position="absolute" top={16} right={16} zIndex={2}>
        <LanguageSwitcher onLight />
      </Box>
      <UnauthFooterCorner />
      {children}
    </Stack>
  );
};
